import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '@datacamp/waffles-core/lib/ico... Remove this comment to see the full error message
import svgSprite from '@datacamp/waffles-core/lib/icons/symbols.svg';
import cx from 'classnames';
import React from 'react';
import { getColorClass } from '../core/colors';
import { jsx as ___EmotionJSX } from "@emotion/react";

/**
 *  @deprecated in favour of directly using icons from waffles
 */
var Icon = function Icon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? null : _ref$color,
      _ref$extraClass = _ref.extraClass,
      extraClass = _ref$extraClass === void 0 ? '' : _ref$extraClass,
      name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size,
      rest = _objectWithoutProperties(_ref, ["color", "extraClass", "name", "size"]);

  return ___EmotionJSX("svg", _extends({}, rest, {
    "aria-label": "".concat(name, " icon"),
    className: cx("dc-icon-".concat(name), getColorClass(color), extraClass),
    fill: "currentColor",
    height: size,
    key: name,
    role: "Img",
    width: size
  }), ___EmotionJSX("use", {
    xlinkHref: "".concat(svgSprite, "#").concat(name)
  }));
};

export default Icon;